import search from '../icons/search-24px.svg';
import React, { Component } from 'react';
import './PostSearch.css'

class PostSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activated: false
        }
    }

    componentDidMount() {

    }

    onClick = (event) => {
        alert("Search posts")
    }

    render() {
        return (
            <div className="post-search" onClick={this.onClick}>
                {!this.state.activated ? (
                    <span>
                        <img className="btn-search" src={search} />
                    </span>) : null
                }
            </div>
        )
    }
}

export default PostSearch;